import { useState, useEffect } from 'react';
import './Modal.css';

function Modal({ isOpen, onClose }) {
  const [submitted, setSubmitted] = useState(false);

  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  // Escape key
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => {
      onClose();
      setSubmitted(false);
    }, 2200);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className={`modal-overlay${isOpen ? ' open' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-box">
        <button className="modal-close" onClick={onClose}>✕</button>

        {/* Header */}
        <div className="modal-head">
          <span className="modal-pre">Book a Meeting</span>
          <h3>Let's Talk About Your Future</h3>
          <p>Fill in your details and pick a time that works for you — we'll take care of the rest.</p>
        </div>

        {/* Body */}
        <div className="modal-body">

          <div className="modal-row">
            <div className="modal-field">
              <label>First Name</label>
              <input type="text" placeholder="John" />
            </div>
            <div className="modal-field">
              <label>Last Name</label>
              <input type="text" placeholder="Smith" />
            </div>
          </div>

          <div className="modal-row">
            <div className="modal-field">
              <label>Email Address</label>
              <input type="email" placeholder="john@example.com" />
            </div>
            <div className="modal-field">
              <label>Phone Number</label>
              <input type="tel" placeholder="+1 (555) 000-0000" />
            </div>
          </div>

          <div className="modal-field">
            <label>Place of Residence</label>
            <input type="text" placeholder="City, State / Country" />
          </div>

          <div className="modal-field">
            <label>What is this meeting about?</label>
            <select defaultValue="">
              <option value="" disabled>Select a topic…</option>
              <option>Retirement Planning Strategy</option>
              <option>Tax-Free Income Planning</option>
              <option>Roth Conversion</option>
              <option>Long-Term Care Planning</option>
              <option>Life Insurance Strategy</option>
              <option>Annuities &amp; Guaranteed Income</option>
              <option>MSO Strategy</option>
              <option>Estate Planning</option>
              <option>General Financial Review</option>
              <option>Other</option>
            </select>
          </div>

          <div className="modal-field">
            <label>Which book are you interested in?</label>
            <select defaultValue="">
              <option value="" disabled>Select a book…</option>
              <option>Escape the Trap: A Secret Guide to Keeping More of What You Earn</option>
              <option>A Pure Vision: Today Secures Your Tomorrow and Beyond</option>
              <option>The Tax-Free Solution for Long-Term Planning</option>
              <option>Facts about Roth and Your Future</option>
              <option>Fact on how Life Insurance Policies Work. Tax-Free</option>
              <option>Will or Trust? Tomorrow is Now</option>
              <option>Social Security Is Annuity: Love All, Serve All</option>
              <option>All Seven Books</option>
            </select>
          </div>

          <div className="modal-field">
            <label>Preferred book format</label>
            <div className="modal-format-options">
              {['eBook', 'Audiobook'].map((fmt) => (
                <label key={fmt} className="modal-format-label">
                  <input type="radio" name="bookFormat" value={fmt} />
                  <span>{fmt}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="modal-field">
            <label>Anything else you'd like us to know?</label>
            <textarea placeholder="Optional — share any details that will help us prepare for your meeting…" />
          </div>

          <div className="modal-divider">Pick a Meeting Time</div>

          {/* Calendly fallback */}
          <div className="calendly-fallback">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8"  y1="2" x2="8"  y2="6" />
              <line x1="3"  y1="10" x2="21" y2="10" />
            </svg>
            <p>Click below to pick your preferred date &amp; time — opens in a new tab.</p>
            <a href="https://calendly.com/sunil-09" target="_blank" rel="noopener noreferrer">
              📅 Open Booking Calendar →
            </a>
          </div>

          <button
            className={`modal-submit${submitted ? ' submitted' : ''}`}
            onClick={handleSubmit}
            disabled={submitted}
          >
            {submitted ? '✓ Submitted! We\'ll be in touch soon.' : 'Submit & Confirm Meeting'}
          </button>

          <p className="modal-note">🔒 Your information is confidential and will never be shared.</p>
        </div>
      </div>
    </div>
  );
}

export default Modal;
